import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import { shrinkThenRemove } from "@universityofmaryland/web-utilities-library/animation";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import { close } from "@universityofmaryland/web-icons-library/controls";
const CreateCloseButton = (props) => {
  const { isThemeDark = false, targetSelector, onBeforeClose } = props;
  const MEDIUM = 768;
  const button = document.createElement("button");
  return new ElementBuilder(button).withClassName("alert-close-button").withAttribute("aria-label", "Close alert").withAttribute("type", "button").withHTML(close).withStyles({
    element: {
      position: "absolute",
      top: token.spacing.lg,
      right: token.spacing.lg,
      color: theme.foreground(isThemeDark),
      ["& rect, & path"]: {
        fill: "currentColor"
      },
      [`@container (max-width: ${MEDIUM}px)`]: {
        top: token.spacing.sm,
        right: token.spacing.sm
      }
    }
  }).on("click", () => {
    if (typeof onBeforeClose === "function") onBeforeClose();
    const wrapper = button.closest(targetSelector);
    if (wrapper instanceof HTMLElement)
      shrinkThenRemove({ container: wrapper });
  }).build();
};
export {
  CreateCloseButton
};
//# sourceMappingURL=closeButton.js.map
